import { render, staticRenderFns } from "./UploadMultiFile.vue?vue&type=template&id=74c1e904&"
import script from "./UploadMultiFile.vue?vue&type=script&lang=js&"
export * from "./UploadMultiFile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports